export class AccountModel {
    public idAccount: string;
    public firstName: string;
    public lastName: string;
    public language: number;
    public email: string;
    public password: string;
    public creeLe: string;
    public phone: string;
    public company: string;
    public lastConnexionDate: Date;
    public modifieLe: Date;
}
